import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaPiggyBank, FaUserMd, FaAward, FaShieldAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './Hero.css';
import doc from "../../images/doc.jpg";
import nap from "../../images/nap.webp";


const Hero = () => {
  const features = [
    {
      icon: <FaTruck className="feature-icon" />,
      title: "Authentic refills, delivered to your door",
      description: "Fast and discrete next-day deliveries",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      icon: <FaPiggyBank className="feature-icon" />,
      title: "Low prices, with or without insurance",
      description: "Competitive pricing on all generics",
      color: "linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)"
    },
    {
      icon: <FaUserMd className="feature-icon" />,
      title: "Pharmacists on call 24/7",
      description: "Expert advice for your medication needs",
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      icon: <FaShieldAlt className="feature-icon" />,
      title: "100% Secure Transactions",
      description: "HIPAA compliant data protection",
      color: "linear-gradient(135deg, #48bb78 0%, #38b2ac 100%)"
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { type: "spring", damping: 10 } }
  };

  return (
    <div className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              We're here for <span className="highlight">you</span>
            </motion.h1>
            
            <motion.p 
              className="hero-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              At Primecare Pharmacy Center, we're committed to providing accessible healthcare solutions for every individual. From filling prescriptions to medical advice, we've got you covered.
            </motion.p>
            
            <motion.div 
              className="hero-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <Link to="/shop" className="btne btn-primary hero-btn">
                Shop Now
                <span className="btn-arrow">→</span>
              </Link>
            </motion.div>
          </div>
          
          <div className="hero-image-container">
            <motion.img 
              src={doc} 
              alt="Doctor" 
              className="hero-main-image"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            />
            
            <div className="accreditation-badges">
              <motion.div 
                className="badge"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <img
                  src="https://ext.same-assets.com/3505992194/3157891197.png"
                  alt="URAC Accredited"
                  className="accreditation-img"
                />
                <div className="accreditation-text">Mail Service Pharmacy<br />01/01/2027</div>
              </motion.div>
              
              <motion.div 
                className="badge"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <img
                  src={nap}
                  alt="NABP Accredited"
                  className="accreditation-img"
                />
                <div className="accreditation-text">Accredited<br />Digital Pharmacy</div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <section className="service-features">
        <div className="features-cont">
          <motion.div 
            className="features-grid"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
          >
            {features.map((feature, index) => (
              <motion.div 
                key={index}
                className="feature-card"
                variants={item}
                whileHover={{ 
                  y: -8,
                  boxShadow: "0 15px 30px -10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="icon-wrapper" style={{ background: feature.color }}>
                  {feature.icon}
                </div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Hero;